import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';

const Label = ({ className, htmlFor, children, ...props }: ComponentProps<'label'>) => {
  return (
    <label
      data-slot="label"
      htmlFor={htmlFor}
      className={cn(
        'flex select-none items-center gap-2 font-medium text-sm leading-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
};

export { Label };
